module.exports = __webpack_public_path__ + "static/media/ProjectHatch.acd5bb07.svg";